module.exports = __webpack_public_path__ + "static/media/a4-l.f5d5a557.png";